module.exports = __webpack_public_path__ + "img/symbol_5.4836463b.png";